<template>
  <div class="main">
    <div class="header">
      <div class="buttons">
        <span>決済URL発行依頼</span>
      </div>
    </div>
    <div class="content">
      <ColorPattern :uniq_key="uniq_key"></ColorPattern>
      <div v-if="cart.length > 0">
        <CartItem v-bind="cartItem" v-for="cartItem in cart" :fixed="true"
                  @clickDelete="clickDelete(cartItem)" @clickChange="clickChange(cartItem)"
                  :key="cartItem.id" :uniq_key="uniq_key"></CartItem>
      </div>
      <div v-else style="text-align: center; padding-top: 3rem; min-height:10rem;">
        カートは空です
      </div>
    </div>
    <div class="footer">
      <div class="band total_prices">
        <span>合計 {{ totalNumber }}枚</span>
        <span>{{ totalPrice | money}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import CartItem from './cart/Item';
  import ColorPattern from './ColorPattern';

  export default {
    name: 'OrderView',
    components: {
      CartItem,
      ColorPattern
    },
    data () {
      return {
        order: null,
        uniq_key: new Date().getTime().toString(16)  + Math.floor(1000 * Math.random()).toString(16),
      };
    },
    created () {
      this.$store.commit('setLoading');
      axios.get('http://admin.harigu.com/api/order/' + this.$route.params.code)
        .then(response => {
          this.order = response.data;
          this.$store.commit('resetLoading');
        });
    },
    computed: {
      cart () {
        if (!this.order) return [];
        return this.order.cart;
      },
      totalNumber () {
        let number = 0;
        this.cart.forEach(cart => {
          number += cart.number;
        });
        return number;
      },
      totalPrice () {
        let price = 0;
        this.cart.forEach(cart => {
          price += cart.price * cart.number;
        });
        return price;
      }
    },
    methods: {
      clickDelete (item) {
        this.$store.commit('removeCart', item);
      },
      clickChange () {
      }
    }
  };
</script>

<style scoped lang="scss">
  .header {
    position: sticky;
    position: -webkit-sticky;
    top: 48px;
    z-index:999;
  }
  .buttons {
    background-color: rgb(128, 127, 128);
    color: #fff;
    font-weight: bold;
    overflow: hidden;
    span {
      float: right;
      display: block;
      padding-right: 10px;
      line-height: 40px;
      height: 40px;
    }
    &:after {
      clear: both;
    }
  }

  .band {
    width: 100%;
    color: #fff;
    padding: 0.5rem;
    display: flex;
    justify-content: space-between;
  }
  .total_prices {
    background-color: #595959;
  }

  .footer {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
  }
</style>
